import { toTitleCase } from 'Shared/utils';

export type TestDriver = {
  description: string;
  driver_information: {
    first_name: string;
    last_name: string;
    date_of_birth: string;
    gender: string;
  };
  license: {
    state: string;
    number: string;
  };
};

export const drivers: { [key: string]: TestDriver } = {
  david_woods: {
    description: 'bindable',
    driver_information: {
      first_name: 'David',
      last_name: 'Woods',
      date_of_birth: '1971-04-13',
      gender: 'male',
    },
    license: {
      state: 'WI',
      number: 'D2224217041801',
    },
  },
  tammy_behner: {
    description: 'bindable',
    driver_information: {
      first_name: 'Tammy',
      last_name: 'Behner',
      date_of_birth: '1975-10-08',
      gender: 'female',
    },
    license: {
      state: 'NE',
      number: 'G20011031',
    },
  },
  mark_brown: {
    description: '',
    driver_information: {
      first_name: 'Mark',
      last_name: 'Brown',
      date_of_birth: '1964-03-22',
      gender: 'male',
    },
    license: {
      number: 'A86902811636',
      state: 'IL',
    },
  },
  charles_boyce: {
    description: 'bindable',
    driver_information: {
      first_name: 'Charles',
      last_name: 'Boyce',
      date_of_birth: '1930-12-16',
      gender: 'male',
    },
    license: {
      state: 'CO',
      number: '885381229',
    },
  },
  eric_malone: {
    description: 'SR-22',
    driver_information: {
      first_name: 'ERIC',
      last_name: 'MALONE',
      date_of_birth: '1942-02-06',
      gender: 'male',
    },
    license: {
      state: 'IL',
      number: 'H63045685280',
    },
  },
  james_cantor: {
    description: 'UW Stop, can reopen',
    driver_information: {
      first_name: 'James',
      last_name: 'Cantor',
      date_of_birth: '1973-04-23',
      gender: 'male',
    },
    license: {
      state: 'NE',
      number: 'H12350778',
    },
  },
  norm_aghabi: {
    description: '',
    driver_information: {
      first_name: 'NORM',
      last_name: 'AGHABI',
      date_of_birth: '1964-03-22',
      gender: 'male',
    },
    license: {
      state: 'IL',
      number: 'A86902811636',
    },
  },
  sherry_dunczak: {
    description: 'multiple accidents, bindable',
    driver_information: {
      first_name: 'SHERRY',
      last_name: 'DUNCZAK',
      date_of_birth: '1975-02-03',
      gender: 'female',
    },
    license: {
      state: 'OH',
      number: 'TE764146',
    },
  },
  maria_peck: {
    description: 'license expired',
    driver_information: {
      first_name: 'Maria',
      last_name: 'Peck',
      date_of_birth: '1961-11-18',
      gender: 'female',
    },
    license: {
      state: 'NE',
      number: 'H12912020',
    },
  },
  len_garcia: {
    description: '',
    driver_information: {
      first_name: 'Len',
      last_name: 'Garcia',
      date_of_birth: '1962-08-14',
      gender: 'female',
    },
    license: {
      state: 'AZ',
      number: 'D01782594',
    },
  },
  margie_strack: {
    description: '',
    driver_information: {
      first_name: 'Margie',
      last_name: 'Strack',
      date_of_birth: '1956-09-07',
      gender: 'female',
    },
    license: {
      state: 'WI',
      number: 'U5957857171615',
    },
  },
  paul_burguera: {
    description: 'license suspended',
    driver_information: {
      first_name: 'Paul',
      last_name: 'Burguera',
      date_of_birth: '1943-06-02',
      gender: 'male',
    },
    license: {
      state: 'NE',
      number: 'H12833842',
    },
  },
  anthony_alvarez: {
    description: '',
    driver_information: {
      first_name: 'Anthony',
      last_name: 'ALVAREZ',
      date_of_birth: '1950-11-26',
      gender: 'male',
    },
    license: {
      state: 'LA',
      number: '7423791',
    },
  },
};

export const driver_options = Object.keys(drivers).reduce(
  (result: { [key: string]: string }, key: string) => {
    const value = toTitleCase(key.split('_').join(' '));
    result[key] = `${value}${
      drivers[key].description ? ` - ${drivers[key].description}` : ''
    }`;
    return result;
  },
  {}
);
